import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { GeneralRoutePaths } from '../enums/route-types.enum';
import { UserService } from '../services/user/user.service';

export const onLeaveGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const userService = inject(UserService);
  const router = inject(Router);

  if (userService.isOnLeaveNow() && state.url !== GeneralRoutePaths.ON_LEAVE) {
    router.navigate([GeneralRoutePaths.ON_LEAVE]);

    return false;
  }

  return true;
};
